import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { CONSTELLATION_UTIL_MAPPING, REPs } from "../../../config";
import { PlanProps, Utilities } from "../../../types";
import { getBestRate, getBestValue, getPlanName, pushToDataLayer } from "../../data";
import { Button } from ".././../styles/Button.styled";
import { getCurrentPromoCode } from "../../../utils/promoCodeUtils";
import { v2EnrollmentHomePath } from "../../../utils/utmParams";
import { PlanSummaryPromote, PlanSummaryRow, } from "../../styles/Enrollment.styled";
import { StyledPlanList, StyledPlanRow, StyledPlanTitle, } from "../../styles/Plan.styled";
import { openPdfInNewTab } from "../../consteNew/utils";

export const PlanModal = ({ show, handleClose, data, selectProduct, hideCloseButton, promoCode, avgMonthlyUse, utility, selectedPlanName, }:
  {
    show: boolean;
    handleClose: Function;
    data: PlanProps[];
    selectProduct: Function;
    hideCloseButton?: boolean;
    promoCode?: string;
    avgMonthlyUse?: string;
    utility?: Utilities | undefined;
    selectedPlanName?: string;
  }) => {
  const priceType = `price${avgMonthlyUse}`;
  let showTitle = false;
  const hostRep = REPs.filter((val) => val.host === true);
  const flex = data.length === 1 ? 92 : 92;
  if (
    hostRep[0] &&
    data &&
    data[0] &&
    String(hostRep[0].providerId) === String(data[0].provider_id)
  ) {
    showTitle = true;
  }

  const location = useLocation();
  const defaultPromoCode = getCurrentPromoCode(location.pathname);

  let bestRatePlan: any = [],
    bestValuePlan: any = [];

  if (data) {
    //const allPlans = data;
    //data.map((item) => { item.plan_name = getPlanName(item, promoCode); });

    const BestValue = getBestValue(promoCode);
    const BestRate = getBestRate(promoCode)
    // bestRatePlan = data.filter((item) => item.plan_name?.indexOf('Credit') && item.plan_name?.indexOf('Credit') > -1)

    // bestValuePlan = data.filter( (item) => BestValue.indexOf(Number(item.plan_id)) > -1 )
    // .sort((a, b) => { return Number((a as any)[priceType]) - Number((b as any)[priceType]);
    // }).slice(0, 1); 

    bestRatePlan = data
      .filter((item) => BestRate.indexOf(Number(item.plan_id)) > -1)
      .sort((a, b) => Number(a.contract_term) < Number(b.contract_term) ? -1 : 1);

  }
  return (
    <Modal /* size={data.length === 1 ? undefined : "lg"}*/ show={show} onHide={() => { handleClose(); }}>
      <Modal.Header style={{/*display: 'unset'*/ }} closeButton={!hideCloseButton} >
        <Modal.Title style={{ color: "#2372B9", maxWidth: "70%", textAlign: "left", lineHeight: 1 }}>{"Best plans for you"}</Modal.Title>
      </Modal.Header>
      {/**To All Plans Load */}
      {/* <Modal.Body style={{ padding: "1rem", display: "flex", justifyContent: "center" }}>
        <StyledPlanList style={{ width: "100%" }}>

          {data && data.length > 0 ? (
            data.map((item: PlanProps, idx: number) => (
              <PlanRow
                data={item}
                handleSelectProduct={selectProduct}
                key={idx}
                flex={flex}
                priceType={priceType || "price1000"}
                avgMonthlyUse={avgMonthlyUse}
                utility={utility}
              />
            ))
          ) : (
            <h5>No data found</h5>
          )}

        </StyledPlanList>
      </Modal.Body> */}

      <Modal.Body style={{ padding: "1rem", display: "flex", justifyContent: "center" }}>
        <StyledPlanList style={{ width: "100%" }}>
          {!showTitle && data && data.length > 0 && (
            <PlanRow
              //data={data[0]}
              data={data.find((plan) => plan.plan_name?.toLowerCase().trim() === "saver's choice 12") || data[0]}// fallback to data[0] if not found (forcefully setting the saversChoice plan as per requirements)
              handleSelectProduct={selectProduct}
              key={0}
              flex={flex}
              priceType={priceType || "price1000"}
              avgMonthlyUse={avgMonthlyUse}
              utility={utility}
            />
          )}
          {data && bestRatePlan.length !== 0 && (
            <StyledPlanTitle>
              {promoCode === defaultPromoCode ? "Best Rate" : "A/C Protect Plan"}
            </StyledPlanTitle>
          )}
          {bestRatePlan && bestRatePlan.length > 0 && (
            <PlanRow
              // Find the lowest price 12-month plan from bestRatePlan
              data={bestRatePlan.reduce((prev: PlanProps, curr: PlanProps) => {
                const prevPrice = priceType ? Number((prev as any)[priceType]) : Number(prev.price1000);
                const currPrice = priceType ? Number((curr as any)[priceType]) : Number(curr.price1000);
                return currPrice < prevPrice ? curr : prev;
              })}

              // Its only shows the first best rate plan no the lowest price plan
              //  data={data.find((plan) => plan.plan_name?.toLowerCase().trim() === selectedPlanName?.toLowerCase().trim()) || data[0]} // Only the first best rate plan
              handleSelectProduct={selectProduct}
              key={"best-0"}
              flex={flex}
              priceType={priceType || "price1000"}
              avgMonthlyUse={avgMonthlyUse}
              utility={utility}
            />
          )}
          {data && bestValuePlan.length !== 0 && (
            <StyledPlanTitle>
              {promoCode === defaultPromoCode ? "Best Value" : "Standard Electricity"}
            </StyledPlanTitle>
          )}
          {data && bestValuePlan.map((item: PlanProps, idx: number) => (
            <PlanRow
              data={item}
              handleSelectProduct={selectProduct}
              key={idx}
              flex={flex}
              priceType={priceType || "price1000"}
              avgMonthlyUse={avgMonthlyUse}
              utility={utility}
            />
          ))}
          {data.length === 0 && <h5>No data found</h5>}
        </StyledPlanList>
      </Modal.Body>
    </Modal>
  );
};

const PlanRow = ({ data, handleSelectProduct, flex, priceType, avgMonthlyUse, utility, }:
  {
    data: any;
    handleSelectProduct: Function;
    flex: Number;
    priceType: string;
    avgMonthlyUse?: string;
    utility: Utilities | undefined;
  }) => {
  const navigate = useNavigate();
  const {
    isEbillRequired,
    provider_id,
    plan_name,
    price1000,
    contract_term,
    cancel_fee,
    cancel_fee_type,
    rate,
    total_rate,
    month,
    plan_incentive_list,
  } = data;
  const location = useLocation();
  const hostRep = REPs.filter((val) => val.host === true);
  let showBtn = false;
  if (
    hostRep[0] &&
    hostRep[0].providerId.toString() === provider_id.toString()
  ) {
    showBtn = true;
  }

  const pushDataLayer = (product: any) => {
    const { plan_name, plan_id, contract_term } = product;
    pushToDataLayer({
      event: "sign_up_start",
      electricity_plan_name: plan_name,
      electricity_rate_plan_id: plan_id,
      electricity_plan_term: contract_term,
      page_path: location.pathname,
      campaign_source: '',
      provider:
        //@ts-ignore
        CONSTELLATION_UTIL_MAPPING[utility.utility_code] ||
        utility?.utility_code,
      zip_code: utility?.zipcode || '',
      user_region: utility?.state_id || '',
    });
  }

  return (
    <StyledPlanRow style={{ flex: `0 0 ${flex}%` }}>
      <div>
        <div className="d-flex align-items-center mb-3">
          <div className="rep-logo me-3" style={{ flexShrink: 0 }}>
            <img
              src={
                provider_id === "196"
                  ? "/images/logo.png"
                  : `https://www.powerlego.com/ApiGateway/v2/logo/provider/${provider_id}`
              }
              width="100%"
              style={{ maxWidth: 125 }}
              alt=""
            />
          </div>
          <div className="plan-name">{plan_name}</div>
        </div>
        <div>
          <PlanSummaryRow>
            <label>Rate{/* (Based on 1,000 kWh) */}:</label>
            {priceType && data[priceType] ? (
              <span>
                {/* <b>{`${priceType ? Number(data[priceType]).toFixed(1) : rate }¢`}</b> */}
                <b>{`${priceType ? Number(data[priceType]).toFixed(1) : price1000 }¢`}</b>
              </span>
            ) : avgMonthlyUse ? (
              <span>
                <b>{`${((month[1] / Number(avgMonthlyUse)) * 100).toFixed(
                  1
                )}¢`}</b>
              </span>
            ) : (
              <span>
                {/* <b>{`${rate}¢`}</b> */}
                <b>{`${price1000}¢`}</b>
              </span>
            )}
          </PlanSummaryRow>
          <PlanSummaryRow>
            <label>{"Plan Length"}:</label>
            <span>{contract_term} Months</span>
          </PlanSummaryRow>
          {plan_incentive_list?.find(
            (incentive: any) => incentive.Description === "Gift Card"
          ) && (
              <div>
                <PlanSummaryRow>
                  <label>Gift Card{/* (Based on 1,000 kWh) */}:</label>
                  <span>
                    <b>
                      $
                      {
                        plan_incentive_list?.find(
                          (incentive: any) =>
                            incentive.Description === "Gift Card"
                        )?.Value
                      }
                    </b>
                  </span>
                </PlanSummaryRow>
              </div>
            )}
          {cancel_fee && cancel_fee_type && (
            <PlanSummaryRow>
              <label>{"Cancellation Fee"}:</label>
              <span style={{ textAlign: "right" }}>
                {`${cancel_fee} (${cancel_fee_type})`}
              </span>
            </PlanSummaryRow>
          )}
        </div>
        <div className="plan-links mt-3">
          {data.yrac && (
            <PlanSummaryRow key={1} narrow>
              <span onClick={(e) => { e.preventDefault(); openPdfInNewTab(data.yrac); }} style={{ cursor: 'pointer' }}>
                <FontAwesomeIcon icon="file-pdf" />
                <span className="ms-2  text-decoration-underline">YRAC</span>
              </span>
            </PlanSummaryRow>
          )}

          {data.terms_url && (
            <PlanSummaryRow key={2} narrow>
              <span onClick={(e) => { e.preventDefault(); openPdfInNewTab(data.terms_url); }} style={{ cursor: 'pointer' }}>
                <FontAwesomeIcon icon="file-pdf" />
                <span className="ms-2  text-decoration-underline">TOS</span>
              </span>
            </PlanSummaryRow>
          )}

          {data.efl_url && (
            <PlanSummaryRow key={3} narrow>
              <span onClick={(e) => { e.preventDefault(); openPdfInNewTab(data.efl_url); }} style={{ cursor: 'pointer' }}>
                <FontAwesomeIcon icon="file-pdf" />
                <span className="ms-2  text-decoration-underline">EFL</span>
              </span>
            </PlanSummaryRow>
          )}
        </div>
        <PlanSummaryPromote>
          {isEbillRequired && <span>Plan requires electronic billing. </span>}
          Please print or save these documents for your reference.
        </PlanSummaryPromote>
      </div>
      {showBtn && (
        <Button
          className="mt-3"
          onClick={() => {
            handleSelectProduct(data);
            localStorage.setItem("selectProduct", JSON.stringify(data));
            pushDataLayer(data)
            navigate(v2EnrollmentHomePath(location.search));
          }}
        >
          Select Plan
        </Button>
      )}
    </StyledPlanRow>
  );
};
